// extracted by mini-css-extract-plugin
export default {"image":"Nea-z","loaded":"Oea-z"};